import request from '@/shared/api/request';

export const deleteBaremetalServer = (id: number): Promise<void> =>
  request({
    url: `/baremetals/${id}/`,
    method: 'DELETE',
  });
